import Content from '../../../../components/Content';

import logo from '../../../../assets/icons/projectY_small.svg';

import { Container, GradientBackground } from './styles';

const Logo = () => {
  return (
    <Container>
      <Content>
        <img src={logo} alt="ProjectY" />
        <h1>Calendário</h1>
      </Content>
      <GradientBackground />
    </Container>
  );
};

export default Logo;
